import React, { useEffect, useState } from 'react';
import { t } from 'i18next';
import moment from 'moment';
import { set } from 'draft-js/lib/DefaultDraftBlockRenderMap';

export default function StepTitle(props) {
  const { step, form } = props;

  const hours = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, '0'));
  const minutes = Array.from({ length: 60 }, (_, i) => String(i).padStart(2, '0'));

  return (
    step === 'titulo' && (
      <div className="page__content fadeIn u-mb-5">
        <div className="new-questions__header">
          <h2 className="new-questions__title">{form?.values?.topic}</h2>
        </div>

        <div className="form__row form__row--columns">
          <div className="form__col">
            <label
              className="form__label"
              htmlFor="delivery_date"
            >
              *Data de publicação
            </label>
            <input
              className="form__control"
              id="publish_at"
              name="publish_at"
              type="date"
              onChange={e => form.setFieldValue('publish_at', e.target.value)}
              value={moment(form?.values?.publish_at).format('YYYY-MM-DD')}
            />
            {form.touched.publish_at && form.errors.publish_at && <span style={{ color: 'red' }}>{form.errors.publish_at}</span>}
          </div>

          <fieldset className="form__col">
            <legend className="form__label">*{t('exams.startHourTitle')}</legend>
            <div className="form__columns">
              <div className="form__col">
                <select
                  className="form__select"
                  name="startHour"
                  id="startHour"
                  aria-label="Hora"
                  onChange={e => form.setFieldValue('start_hour', e.target.value)}
                  value={form?.values?.start_hour ? form?.values?.start_hour : 'emptyHour'}
                >
                  <option
                    disabled
                    value={'emptyHour'}
                  >
                    Hora
                  </option>
                  {hours.map(i => (
                    <option
                      key={i}
                      value={parseInt(i)}
                    >
                      {i}
                    </option>
                  ))}
                </select>
                {form?.touched?.start_hour && form?.errors?.start_hour && <span style={{ color: 'red' }}>{form?.errors?.start_hour}</span>}
              </div>

              <div className="form__col">
                <select
                  className="form__select"
                  name="startMinute"
                  id="startMinute"
                  aria-label="Minuto"
                  onChange={e => form.setFieldValue('start_minute', e.target.value)}
                  value={form?.values?.start_minute ? form?.values?.start_minute : 'emptyMinute'}
                >
                  <option
                    disabled
                    value={'emptyMinute'}
                  >
                    Minuto
                  </option>
                  {minutes.map(i => (
                    <option
                      key={i}
                      value={parseInt(i)}
                    >
                      {i}
                    </option>
                  ))}
                </select>
                {form?.touched?.start_minute && form?.errors?.start_minute && <span style={{ color: 'red' }}>{form?.errors?.start_minute}</span>}
              </div>
            </div>
          </fieldset>

          <div className="form__col">
            <label
              className="form__label"
              htmlFor="delivery_date"
            >
              *Prazo de entrega
            </label>
            <input
              className="form__control"
              id="delivery_date"
              name="delivery_date"
              type="date"
              onChange={e => form.setFieldValue('delivery_date', e.target.value)}
              value={moment(form?.values?.delivery_date).format('YYYY-MM-DD')}
            />
            {form.touched.delivery_date && form.errors.delivery_date && <span style={{ color: 'red' }}>{form.errors.delivery_date}</span>}
          </div>
        </div>

        <fieldset className="form__row">
          <legend className="form__label">Modo de correção</legend>

          <p>Por padrão, as redações são corrigidas automaticamente pela plataforma, mas você pode revisar os comentários e nota antes de enviar para os alunos</p>
        </fieldset>
        <fieldset className="form__row">
          <legend className="form__label">Quantidade de envios do mesmo tema </legend>

          <input
            type="checkbox"
            id="multiple-submissions"
            name="multiple-submissions"
            className="form__check-input"
            checked={form?.values?.['allow_multiple_submissions']}
            onClick={() => form.setFieldValue('allow_multiple_submissions', !form?.values?.['allow_multiple_submissions'])}
            style={{ marginRight: '8px' }}
          />
          <label for="multiple-submissions">Permitir que os estudantes enviem mais de uma versão do mesmo tema</label>
        </fieldset>

        <span className="form__text u-mt-3">
          <strong>* {t('warning.requiredField')}</strong>
        </span>
      </div>
    )
  );
}
